import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaymentMethodsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { SLICE_NAME } from './models';
import {
  IGetPaymentMethodsDTO,
  IGetPaymentMethodsResponse,
  IUpdatePaymentMethodDTO,
  IUpdatePaymentMethodResponse,
} from '@/models/paymentMethod.model';

export const getPaymentMethods = createAsyncThunk<
  IGetPaymentMethodsResponse,
  IGetPaymentMethodsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getPaymentMethods`,
  async (params) => {
    const response = await PaymentMethodsAPI.getPaymentMethods(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updatePaymentMethod = createAsyncThunk<
  IUpdatePaymentMethodResponse,
  IUpdatePaymentMethodDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updatePaymentMethod`,
  async (data) => {
    const response = await PaymentMethodsAPI.updatePaymentMethod(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
